import { TYPE_MAPPING } from '@constants/fileTypes'
import type { FileTypeKeys } from '@constants/fileTypes'

export const fileTypeMapping = (fileTypes: FileTypeKeys[]): string[] => {
  if (!fileTypes) {
    return ['*']
  }

  const accepts: string[] = []

  fileTypes.forEach((fileType: FileTypeKeys) => {
    accepts.push(...TYPE_MAPPING[fileType])
  })

  return accepts
}
